// @ts-check
import { registerPlugin } from "@mailonline/dmg-ads-core/src/plugin-registry";

registerPlugin('cmpConfig', { 
  gdpr: { enabledIfDissent: true },
  ccpa: { enabledIfDissent: true },
  init,
})

async function init({ pageGeoInfo, setConfig }) {
  const {REGION_CODE} = await pageGeoInfo()

  const ccpaFrameworkText = {
    CO: 'Colorado Consumer Privacy Act',
    CT: 'Connecticut Data Privacy Act',
    CA: 'California Consumer Privacy Act',
    VA: 'Virginia Consumer Data Protection Act'
  }

  ccpaFrameworkText[REGION_CODE] && (setConfig('ccpa.renderConfig.layerTwo.ccpaFrameworkText', ccpaFrameworkText[REGION_CODE]))
}
